export default "__VITE_ASSET__DuZZ6MpU__"